import { Button } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import type { ProductFormIssue } from '../product-form.ts';
import styles from './ProductEditor.module.css';
import { fieldLabelOfIssue } from './sections.ts';

export const ErrorSummary = ({
  issues,
  onFocus,
}: {
  issues: readonly ProductFormIssue[];
  onFocus: (issue: ProductFormIssue) => void;
}) => {
  const { t } = useTranslation();
  if (issues.length === 0) return null;
  return (
    <section role="alert" aria-labelledby="product-editor-errors" className={styles['summary']}>
      <h2 id="product-editor-errors" className={styles['summaryTitle']}>
        {t('productEditor.errorsTitle')}
      </h2>
      <ul className={styles['summaryList']}>
        {issues.map((issue) => (
          <li key={issue.path.join('.')}>
            <strong className={styles['summaryField']}>{t(fieldLabelOfIssue(issue))}</strong>
            {t(`productEditor.errors.${issue.message}`)}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onFocus(issue);
              }}
            >
              {t('productEditor.fixField')}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
};
